var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenTpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 396.32,
    height: 396.319,
    viewBox: "0 0 396.32 396.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_643",
    "data-name": "Pfad 643",
    d: "M397.075,92.9H298a79.267,79.267,0,0,0-79.264,79.264V409.958A79.268,79.268,0,0,0,298,489.222H535.786a79.269,79.269,0,0,0,79.265-79.264v-99.08a19.816,19.816,0,0,0-39.633,0v99.08a39.646,39.646,0,0,1-39.632,39.633H298a39.634,39.634,0,0,1-39.632-39.633V172.167A39.621,39.621,0,0,1,298,132.535h99.08a19.816,19.816,0,0,0,0-39.632ZM547.4,132.535H476.339a19.816,19.816,0,1,1,0-39.632h118.9a19.823,19.823,0,0,1,19.816,19.816v118.9a19.816,19.816,0,0,1-39.633,0v-71.06L430.9,305.073a19.813,19.813,0,0,1-28.02-28.02Z",
    transform: "translate(-218.731 -92.903)",
    fill: "#454545",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTpIcon);
export default __webpack_public_path__ + "static/media/OpenTPIcon.761133f71ce39fa00f9a3248f5de436f.svg";
export { ForwardRef as ReactComponent };